import { DEFAULT_ROUTE_OPS_STRATEGY, isRouteOpsStrategy, RouteOpsStrategy } from 'types/modules/routing/Strategy'

import { RouteOpsStrategyRootStateSlice, selectPersistedRouteOpsStrategy } from './persistentRouteOpsStrategySlice'

// Precedence and the tenant clamp: utils/routeStopOperations/README.md, "Strategies".

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    __routeOpsStrategy?: unknown
  }
}

const readWindowOverride = (): RouteOpsStrategy | undefined => {
  const win = (globalThis as { window?: Window }).window
  // eslint-disable-next-line no-underscore-dangle
  const candidate = win?.__routeOpsStrategy
  return isRouteOpsStrategy(candidate) ? candidate : undefined
}

const readEnvOverride = (): RouteOpsStrategy | undefined => {
  const candidate = (globalThis as { process?: { env?: Record<string, string | undefined> } }).process?.env?.REACT_APP_ROUTE_OPS_STRATEGY
  return isRouteOpsStrategy(candidate) ? candidate : undefined
}

// v2-pipeline's future-daily fan-out misplaces end-of-week stops, so an override naming it gets the tenant's default.
export const clampStrategyToTenant = (strategy: RouteOpsStrategy, isRouteManagerV3Enabled: boolean): RouteOpsStrategy => {
  const tenantDefault: RouteOpsStrategy = isRouteManagerV3Enabled ? 'v3-slot' : 'v1-bulk'
  if (strategy === 'v2-pipeline') return tenantDefault
  return strategy === 'v3-slot' && !isRouteManagerV3Enabled ? 'v1-bulk' : strategy
}

// The gate is a default as well as a ceiling — clamping alone left `v3-slot` unreachable.
export const getEffectiveStrategy = (state: RouteOpsStrategyRootStateSlice, isRouteManagerV3Enabled = false): RouteOpsStrategy => {
  const fromWindow = readWindowOverride()
  if (fromWindow) return fromWindow

  const fromEnv = readEnvOverride()
  if (fromEnv) return fromEnv

  const persisted = selectPersistedRouteOpsStrategy(state)
  if (persisted) return persisted

  return isRouteManagerV3Enabled ? 'v3-slot' : DEFAULT_ROUTE_OPS_STRATEGY
}
